import styled from "styled-components";

export const Text = styled.p`
  font-family: ${props => props.theme.fonts.body};
  font-size: 14px;
  line-height: 1.5;
  text-align: center;
  color: ${props => props.theme.colors.textPrimary};

  @media (min-width: 768px) {
    font-size: 17px;
  }
`;